import { createTheme } from "@mui/material/styles";

const clivetTheme = createTheme({
  palette: {
    primary: {
      main: "#007CB1", // Clivet plava
      light: "#FFFFFF",
      other: "#007CB1",
      dark: "#007CB1",
    },
    secondary: {
      main: "#80caef",
      light: "#e3f2fd",
      dark: "#2978a0",
    },
    error: {
      main: "#d32f2f",
    },
    warning: {
      main: "#ed6c02",
    },
    info: {
      main: "#0288d1",
    },
    success: {
      main: "#2e7d32",
    },
    dark: {
      main: "#52595b",
    },
  },
  typography: {
    fontFamily: "Montserrat",
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#007CB1",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 4,
        },
      },
    },
  },
});

export default clivetTheme;
